// extracted by mini-css-extract-plugin
export default {"tabBodyItemActive":"index_tabBodyItemActive_07NS8","tabBodyItem":"index_tabBodyItem_VLOcT"};